import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var bnrimg = require('./../../images/banner/3.jpg');

class ProjectCarousel extends React.Component {
    state = {
        projects: [],
        loading: true
    };

    componentDidMount() {
        axiosClient.get(apiConfig.PROJECTS.GET_ALL)
            .then(res => {
                this.setState({
                    projects: res.data.data || [],
                    loading: false
                });
            })
            .catch(err => {
                console.error("Error fetching projects for carousel", err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { projects, loading } = this.state;

        const options = {
            loop: projects.length > 3,
            autoplay: false,
            center: false,
            items: 3,
            margin: 40,
            nav: true,
            dots: false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: { items: 1 },
                768: { items: 2 },
                991: { items: 3 },
                1200: { items: 4 }
            }
        };

        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Broad vision. Careful thought. Hand-crafted design." pagename="Project carousel" bgimage={bnrimg} />

                    <div className="section-full p-tb80 bg-gray inner-page-padding">
                        <div className="container-fluid">
                            <div className="section-content">
                                {loading ? (
                                    <div className="text-center p-a50">Loading projects...</div>
                                ) : projects.length === 0 ? (
                                    <div className="text-center p-a50">No projects found.</div>
                                ) : (
                                    <div className="work-carousel-outer">
                                        <OwlCarousel
                                            key={projects.length}
                                            className="owl-carousel work-carousel owl-btn-vertical-center"
                                            {...options}
                                        >
                                            {projects.map((item, index) => (
                                                <div key={item.id || index} className="item mt-box">
                                                    <div className="mt-img-effect mt-img-overlay7">
                                                        <img
                                                            src={item.featured_image}
                                                            alt={item.title}
                                                            style={{ width: '100%', height: '350px', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                    <div className="mt-info p-a30">
                                                        {item.service && (
                                                            <span className="text-primary font-weight-600 font-12 text-uppercase m-b10 block">
                                                                {item.service.name}
                                                            </span>
                                                        )}
                                                        <h4 className="m-b15 m-t0">
                                                            <NavLink to="/project-detail" state={{ projectSlug: item.slug }}>
                                                                {item.title}
                                                            </NavLink>
                                                        </h4>
                                                        <p>{(item.short_description || item.description || '').substring(0, 90)}...</p>
                                                        <NavLink
                                                            to="/project-detail"
                                                            state={{ projectSlug: item.slug }}
                                                            className="site-button btn-effect"
                                                        >
                                                            Read More
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            ))}
                                        </OwlCarousel>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default ProjectCarousel;
